import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { IoService } from '../../../services/io.service';
import { Subscription } from 'rxjs';
import { MatTable } from '@angular/material';
import { rowsAnimation } from '../../../xanimations/animations';

const TABLE_MAX_ROWS = 10;
export interface FsmState {
  time: string;
  trigger: string;
  state: string;
  n: number;
}

@Component({
  selector: 'app-dashboard-preparation',
  templateUrl: './dashboard-preparation.component.html',
  styleUrls: ['./dashboard-preparation.component.css'],
  animations: [rowsAnimation]
})
export class DashboardPreparationComponent implements OnInit, OnDestroy {
  private subDeviceCcdFsmState: Subscription;
  private subDeviceCcdSpsError: Subscription;
  private levels: object = {level_coffee: 0, level_chocolat: 0, level_sugar: 0 };
  triggerAlive: object;
  errorText = '';
  displayedColumns: string[] = ['time', 'trigger', 'state', 'n'];
  private fsmStateList: FsmState[] = Array.from({length: TABLE_MAX_ROWS}, () => ({ time: '', trigger: '', state: '', n: 0 }));

  @ViewChild('dataTable') dataTable: MatTable<FsmState>;

  constructor(private ioService: IoService) { }

  ngOnInit() {
    this.subDeviceCcdFsmState = this.ioService.getDeviceEvents('coffee_cup_detector.fsm_state').subscribe(this.addFsmState);

    this.subDeviceCcdSpsError = this.ioService.getDeviceEvents('coffee_cup_detector.sps_error').subscribe(m => {
      console.log(m);
      this.errorText = m.error;
      this.triggerAlive = {};
    });
  }

  addFsmState = m => {
    console.log(m);
    this.triggerAlive = {};
    const time = (new Date(m.t - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(11, 19).replace('T', ' ');
    const fsmState: FsmState = { time, trigger: m.trigger, state: m.destination, n: 1};
    const freeIndex = this.fsmStateList.findIndex(s => !s.n);
    if (freeIndex !== -1) {
      this.fsmStateList[freeIndex] = fsmState;
    } else {
      const lastState =  this.fsmStateList[TABLE_MAX_ROWS - 1];
      if (lastState.trigger === fsmState.trigger && lastState.state === fsmState.state) {
        lastState.time = time;
        lastState.n++;
      } else {
        this.fsmStateList.shift();
        this.fsmStateList[TABLE_MAX_ROWS - 1] = fsmState;
      }
    }
    this.dataTable.renderRows();
  }

  ngOnDestroy() {
    if (this.subDeviceCcdFsmState) { this.subDeviceCcdFsmState.unsubscribe(); }
    if (this.subDeviceCcdSpsError) { this.subDeviceCcdSpsError.unsubscribe(); }
  }

}
